<template>
  <section class="aboutUs container" id="about">
    <div class="buttons">
      <div class="download-container">
        <div class="icon">
          <img  src="/apple.svg" alt="" />
        </div>
        <div class="desc">
          <p>{{$t('common.getItOn')}}</p>
          <h5>{{$t('common.appStore')}}</h5>
        </div>
      </div>

      <div class="download-container">
        <div class="icon">
          <img  src="/play-store.svg" alt="" />
        </div>
        <div class="desc">
          <p>{{$t('common.getItOn')}}</p>
          <h5>{{$t('common.playStore')}}</h5>
        </div>
      </div>
    </div>
    <div class="faker">
      <div class="about-content">
        <h1 class="main-title">{{ $t('common.aboutRahal') }}</h1>

        <div class="content">
          <cardWithMobile
            :title="$t('saryahLanding.about.aboutTiltle')"
            :desc="$t('saryahLanding.about.aboutSecOne')"
            img="/earth.png"
            :noBackground="true"
          />
          <cardWithMobile
            img="/3d-3.png"
            :reverse="true"
            :title="
              $t('saryahLanding.saryahClient.bookmark')
            "
            id="services"
            :desc="$t('saryahLanding.saryahClient.desc')"
          />
          <cardWithMobile
          img="/test-3d-2.png"
            :title="$t('saryahLanding.saryahTour.head')"
            :desc="$t('saryahLanding.saryahTour.desc')"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import cardWithMobile from './card-with-mobile.vue';
export default {
  components: {
    cardWithMobile,
  },
};
</script>


<style lang="scss" scoped>
*{
  overflow: hidden !important;
}
.faker {
  max-width: 100%;
  display: flex;
  align-items: end;
  overflow: hidden !important;
}

/*
.faker::after {
  position: absolute;
  content: '';
  right: -200px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: #ed27552c;
  z-index: -2;

}
.faker::before {
  position: absolute;
  content: '';
  right: -100px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  transform: translateY(-100px);
  background: #ffffff;
  z-index: -1;
}
*/

section {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden !important;
}



section::after {
  position: absolute;
  content: '';
  left: -200px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: #ed27552c;
  z-index: -2;
}
section::before {
  position: absolute;
  content: '';
  left: -100px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  transform: translateY(100px);
  background: #ffffff;
  z-index: -1;
}


@media (width < 768px) {
  section::after{
    width: 200px;
    height: 200px;
    left: -100px;
  }

  section::before{
    width: 100px;
    height: 100px;
    left: -50px;
    transform: translateY(50px);
  }
  .faker::after{
    width: 200px;
    height: 200px;
    right: -100px;
  }

  .faker::before{
    width: 100px;
    height: 100px;
    right: -50px;
    transform: translateY(-50px);
  }
}
.about-content {
  margin-top: 30px;
  width: 100%;
}

.content {
  margin-top: 70px;
  width: 100%;
}

@media (width < 768px) {
  .buttons{
    display: none;
  }
  section {
    margin-top: 0px;}

    .content {
      margin-top: 20px;
      width: 100%;
    }
}
</style>